<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
  
  <!--begin::Main-->
  <div  class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">
  
      <!--begin::Toolbar-->
      <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
        <!--begin::Toolbar container-->
        <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
          <!--begin::Page title-->
          <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
              <h1 class="page-heading"> <svg width="32" height="29" viewBox="0 0 32 29" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_82_1744)">
                    <path
                      d="M21.795 7.11531C19.8257 7.11531 18.2199 5.51738 18.2199 3.55766C18.2199 1.59793 19.8257 0 21.795 0C23.7643 0 25.3701 1.59793 25.3701 3.55766C25.3701 5.51738 23.7643 7.11531 21.795 7.11531ZM16.3112 4.58274C16.3112 2.05017 14.2509 0.0301492 11.7363 0.0301492C9.19127 0.0301492 7.16135 2.08032 7.16135 4.58274C7.16135 7.11531 9.22157 9.13533 11.7363 9.13533C14.2812 9.13533 16.3112 7.08516 16.3112 4.58274ZM27.0667 15.9491C27.5212 15.9491 27.8848 15.5572 27.8242 15.105C27.3394 11.6076 25.8245 8.1404 21.795 8.1404C19.5227 8.1404 18.0381 9.25593 17.0989 10.8539C17.7654 11.4267 18.3714 12.09 18.8561 12.904C19.4015 13.7784 19.8863 14.8035 20.2498 15.9793H27.0667V15.9491ZM4.01041 19.2053C3.91952 19.8686 4.43457 20.5017 5.13142 20.5017H18.3411C19.0379 20.5017 19.553 19.8987 19.4621 19.2053C18.7956 14.8035 16.8565 10.4619 11.7363 10.4619C6.61599 10.4619 4.67695 14.8035 4.01041 19.2053Z"
                      fill="#265D91" />
                  </g>
                  <defs>
                    <filter id="filter0_d_82_1744" x="0" y="0" width="31.8308" height="28.5017"
                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_82_1744" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_82_1744" result="shape" />
                    </filter>
                  </defs>
                </svg>
                Candidats
              </h1>
              <!--begin::Menu-->
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <!--begin::Item-->
              <li class="breadcrumb-item text-muted">
                <a routerLink="/accueil" class="text-muted ">Accueil</a>
              </li>
              <!--end::Item-->
              <!--begin::Item-->
              <li class="breadcrumb-item">
                <span class="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <!--end::Item-->
              <!--begin::Item-->
              <li class="breadcrumb-item text-muted">Candidats</li>
              <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
          </div>
          <!--end::Page title-->
          <!--begin::Actions-->
  
          <!--end::Actions-->
        </div>
        <!--end::Toolbar container-->
      </div>
      <!--end::Toolbar-->
      <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
        <!--begin::Content container-->
        <div id="kt_app_content_container" class="app-container container-fluid">
          <!--begin::Card-->
          <div class="card">
            <!--begin::Card header-->
  
            <div class="card-body" [formGroup]="searchForm">
              <div class="title mb-3">
                <h4>Recherche</h4>
              </div>
              <div class="row mb-5">
                <div class="col-lg-6">
                  <div class="input-group search-libre">
                    <span class="input-group-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                            fill="none">
                            <path
                                d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                fill="#7E7C7C" />
                        </svg>
                    </span>
        
                    <input type="text" data-kt-customer-table-filter="search" 
                        class="form-control ps-5" placeholder="Rechercher" formControlName="search" (keyup.enter)="searchCandidat()"/>
                        <div class="tooltip-container tooltip-info">
                          <div class="tooltip-trigger"><i class="fa-solid fa-circle-info" style="font-size: 20px;"></i></div>
                          <div class="tooltip-content">
                            <div class="content">
                              <h4>Opérateur AND :</h4>
                              <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent inclure plusieurs termes.
                              </p>
                              <p>Exemple : software AND engineer renverra des profils qui mentionnent à la fois "software" et "engineer".
                              </p>
                              <h4>Opérateur OR :</h4>
                              <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent inclure l'un des termes.
                              </p>
                              <p>Exemple : sales OR marketing renverra des profils qui mentionnent soit "sales" soit "marketing".
                              </p>
                              <h4>Opérateur NOT :</h4>
                              <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des résultats.
                              </p>
                              <p>Exemple : developer NOT manager renverra des profils qui mentionnent "developer" mais pas "manager".
                              </p>
                              <h4>Guillemets pour une expression exacte :</h4>
                              <p>Utilisez des guillemets pour rechercher une expression exacte.
                              </p>
                              <p>Exemple : "product manager" renverra des profils qui mentionnent exactement "product manager".
                              </p>
                              <h4>Parenthèses pour grouper des opérations :</h4>
                              <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des opérations.
                              </p>
                              <p>Exemple : (sales OR marketing) AND manager renverra des profils qui mentionnent "sales" ou "marketing" et "manager".
                              </p>
                              <h4>Recherche standard :</h4>
                              <p>Si aucun opérateur n'est spécifié dans la recherche, le texte sera interprété comme s'il était entre guillemets.
                              </p>
                              <p>Exemple : La recherche product manager sera traitée comme "product manager", suivant la règle 4.
                              </p>
                            </div>
                          </div>
                        </div>
                </div>
                 </div>
              </div>
             <div class="tools">
              <div class="row mb-3">
               
             
                <div class="col-lg-3">
                  <input type="text" name="nom" id="nom" formControlName="desired_workstation" 
                    class="form-control form-control-solid mb-3" placeholder="Poste">
                </div>
  
                <div class="col-lg-3  mb-3">
                  <ng-select [items]="skillsList"  bindLabel="name_FR"
                    formControlName="skillsOr" bindValue="name_FR" [multiple]="true" [placeholder]="'Compétences (ou)'"
                    [notFoundText]="'Aucun élément trouvé'" autoComplete>
                  </ng-select>
  
                </div>
                <div class="col-lg-3  mb-3">
                  <ng-select [items]="skillsList" formControlName="skillsAnd"
                    bindLabel="name_FR" bindValue="name_FR" [multiple]="true" [placeholder]="'Compétences (et)'"
                    [notFoundText]="'Aucun élément trouvé'" autoComplete>
                  </ng-select>
                </div>
                <div class="col-lg-3">
                  <input type="number"  min="0" oninput="validity.valid||(value='0');"  name="exper" formControlName="min_experience_years" id="experience_min"
                    class="form-control form-control-solid mb-3" placeholder=" Expérience min ">
  
                </div>
  
              </div>
              <div class="row mb-3" *ngIf="seeMore">
  
               
                <div class="col-lg-3">
                  <input type="number"  min="0" oninput="validity.valid||(value='0');" name="exper" formControlName="max_experience_years" id="experience_max"
                    class="form-control form-control-solid mb-3" placeholder=" Expérience max">
  
                </div>
                <div class="col-lg-3 mb-3">
                  <ng-select [items]="disponibilite"  formControlName="availability" [notFoundText]="'Aucun élément trouvé'"
                    bindLabel="name" bindValue="id" [placeholder]="'Disponibilité'" [multiple]="true" autoComplete>
                  </ng-select>
                </div>
                <div class="col-lg-3 mb-3">
                  <div class="combined-input">
                    <input type="number" name="number1" min="0" formControlName="tjm" (keypress)="keyPress($event)"
                      class="nb1" placeholder="TJM" id="tjm">
                    <div class="euro">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                          fill="#4B4B4B" />
                      </svg>
                    </div>
                    <input type="number" min="0" formControlName="tjm_range" (keypress)="keyPress($event)" name="number2"
                      class="nb2" value="1" id="marge_tjm">
                    <div class="icon">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                          fill="#4B4B4B" />
                      </svg>
                    </div>
                    <div class="plusetmois">
                      <i class="fa-solid fa-plus-minus"></i>
                    </div>
                  </div>
                </div>
  
                <div class="col-lg-3 mb-3">
                  <div class="combined-input">
                    <input type="number" name="number1" min="0" (keypress)="keyPress($event)"
                      formControlName="desired_salary" class="nb1" placeholder="Salaire" id="Salaire">
                    <div class="euro">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                          fill="#4B4B4B" />
                      </svg>
                    </div>
                    <input type="number" min="0" (keypress)="keyPress($event)" formControlName="desired_salary_range" (change)="alreadyConverted=false" (input)="onSalaryRangeInput($event)"
                      name="number2" class="nb2" value="1" id="marge_tjm">
                    <div class="icon">
                      <svg width="20" height="15" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                          fill="#4B4B4B" />
                        <path
                          d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                          fill="#4B4B4B" />
                      </svg>
                    </div>
                    <div class="plusetmois">
                      <i class="fa-solid fa-plus-minus"></i>
                    </div>
                  </div>
  
                </div>
                <div class="col-lg-3  mb-3">
                  <ng-select [items]="contratRequest"  formControlName="desired_contract" [notFoundText]="'Aucun élément trouvé'"
                    bindLabel="label" bindValue="id" [multiple]="true" [placeholder]="'Contrat demandé'" autoComplete>
                  </ng-select>
  
                </div>
                <div class="col-lg-3">
                  <div class="input-group mb-5">
                    <input type="number"  min="0" oninput="validity.valid||(value='0');" formControlName="score" class="form-control mb-3" placeholder="Score"
                      aria-label="Amount (to the nearest dollar)" />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
                <div class="col-lg-3  mb-3">
                  <ng-select formControlName="current_country"  [items]="paysList" [notFoundText]="'Aucun élément trouvé'"
                    bindLabel="name" bindValue="name" [placeholder]="'Pays de résidence'" autoComplete>
                  </ng-select>
                </div>
                <div class="col-lg-3  mb-3">
                  <ng-select (change)="onCountryChange('add')" [items]="paysList" [multiple]="true"
                  id="pays_destinataire" bindLabel="name" bindValue="name" [placeholder]="'Pays destinataire'"
                  autoComplete formControlName="destination_country"  [notFoundText]="'Aucun élément trouvé'"  autoComplete>
                  <ng-template ng-optgroup-tmp let-item="item">
                    {{ item.name || "Unnamed group" }}
                  </ng-template>
                </ng-select>
  
                </div>
                <div class="col-lg-3  mb-3">
                  <ng-select  [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" [multiple]="true"
                    (change)="onMobilityChange('add')" id="mobilite" bindLabel="name"
                    formControlName="mobility" 
                    [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'Mobilité'" autoComplete>
                  </ng-select>
                </div>
              
  
                <div class="col-lg-3 mb-3">
                  <div class="position-relative d-flex align-items-center calenderDate">
                    <!--begin::Datepicker-->
                   

                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Derniére maj" inputId="yearpicker"
                      formControlName="date_last_update" class="form-control"
                       ></p-calendar>

                    <!--end::Datepicker-->
                  </div>
                </div>
         
              </div>
  
              <div class="see-more mb-5">
                <a class="" (click)="seeMore=!seeMore">Voir {{!seeMore?'plus':'moins'}} de critères de recherche</a>
              </div>
              <div class="mb-3 search-btn d-flex justify-content-end">
                <div class="align-items-center recherche">
                  <button type="button" class="me-5" (click)="searchCandidat()">
                    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                        fill="white" />
                    </svg>
                    Rechercher</button>
                </div>
                <div class="resett-btn">
                  <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                    title="Réinitialiser">
                    <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                  </div>
                </div>
              </div>
  
             </div>
  
            </div>
          </div>
        </div>
        <!--end::Content container-->
      </div>
  
  
      <!--begin::Content-->
  
      <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-15">
        <!--begin::Content container-->
        <div id="kt_app_content_container" class="app-container container-fluid">
          <!--begin::Card-->
          <div class="card">
            <!--begin::Card header-->
            <div class="d-flex flex-wrap  header-grid align-items-center">
              <div class="section_title">
                <h1 class="section-heading my-3">Liste des candidats</h1>
              </div>
             
              <div class="d-flex justify-content-end">
                <ul class="nav nav-pills me-5">
                  <li class="nav-item m-0">
                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3" data-bs-toggle="tab"
                      href="#kt_project_targets_card_pane">
                      <i class="ki-duotone ki-element-plus fs-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                        <span class="path3"></span>
                        <span class="path4"></span>
                        <span class="path5"></span>
                      </i>
                    </a>
                  </li>
                  <li class="nav-item m-0">
                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active" data-bs-toggle="tab"
                      href="#kt_project_targets_table_pane">
                      <i class="ki-duotone ki-row-horizontal fs-2">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!--begin::Tab nav-->
            <div class="card-toolbar">

             <div class="actions-btns">
              <div class="d-flex justify-content-end export" data-kt-customer-table-toolbar="base">

                <!--begin::Export-->
                <button type="button" class="btn btn-light-primary me-3"
                (click)="downloadFiles('multiple',undefined,'response')">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.38333 13.1551H10.6167C10.9297 13.1551 11.2396 13.0917 11.5287 12.9685C11.8179 12.8453 12.0806 12.6648 12.3019 12.4371C12.5233 12.2095 12.6988 11.9392 12.8186 11.6418C12.9384 11.3444 13 11.0256 13 10.7037V7.36085C13 7.12443 12.9087 6.89769 12.7462 6.73051C12.5836 6.56334 12.3632 6.46942 12.1333 6.46942C11.9035 6.46942 11.683 6.56334 11.5205 6.73051C11.358 6.89769 11.2667 7.12443 11.2667 7.36085V10.7037C11.2667 10.881 11.1982 11.0511 11.0763 11.1765C10.9544 11.3018 10.7891 11.3723 10.6167 11.3723H2.38333C2.21094 11.3723 2.04561 11.3018 1.92371 11.1765C1.80182 11.0511 1.73333 10.881 1.73333 10.7037V7.36085C1.73333 7.12443 1.64202 6.89769 1.47949 6.73051C1.31696 6.56334 1.09652 6.46942 0.866667 6.46942C0.636812 6.46942 0.416372 6.56334 0.253841 6.73051C0.0913094 6.89769 0 7.12443 0 7.36085V10.7037C0 11.3539 0.2511 11.9774 0.698062 12.4371C1.14502 12.8969 1.75123 13.1551 2.38333 13.1551Z"
                    fill="#265D91" />
                  <path
                    d="M6.49986 0.0600586C6.27001 0.0600586 6.04957 0.153976 5.88704 0.321152C5.7245 0.488327 5.6332 0.715066 5.6332 0.951487V6.56526L4.31586 5.33954C4.14548 5.18085 3.92079 5.09827 3.69121 5.10997C3.46164 5.12167 3.24598 5.2267 3.0917 5.40194C2.93741 5.57719 2.85712 5.8083 2.86849 6.04444C2.87987 6.28057 2.98198 6.50239 3.15236 6.66109L5.9192 9.23509C5.93653 9.25069 5.95386 9.26183 5.9712 9.2752C5.98853 9.28857 6.01236 9.30863 6.03403 9.32423C6.05996 9.34055 6.08672 9.35542 6.1142 9.3688L6.1792 9.40223C6.21035 9.41454 6.24218 9.42496 6.27453 9.43343L6.3352 9.45126C6.44387 9.47395 6.55586 9.47395 6.66453 9.45126L6.7252 9.43343C6.75753 9.42493 6.78936 9.41451 6.82053 9.40223L6.88553 9.3688C6.913 9.35543 6.93977 9.34055 6.9657 9.32423C6.98736 9.30863 7.00686 9.29303 7.02853 9.2752C7.05019 9.25737 7.0632 9.25069 7.08053 9.23509L9.84736 6.66109C9.93173 6.58251 10.0002 6.48761 10.0489 6.3818C10.0976 6.276 10.1256 6.16136 10.1312 6.04444C10.1369 5.92752 10.1201 5.8106 10.0818 5.70036C10.0435 5.59012 9.98443 5.48872 9.90803 5.40194C9.83163 5.31517 9.73937 5.24472 9.6365 5.19463C9.53364 5.14453 9.42218 5.11576 9.30851 5.10997C9.19484 5.10417 9.08116 5.12147 8.97399 5.16086C8.86681 5.20025 8.76823 5.26097 8.68386 5.33954L7.36653 6.56526V0.951487C7.36653 0.715066 7.27522 0.488327 7.11269 0.321152C6.95016 0.153976 6.72972 0.0600586 6.49986 0.0600586Z"
                    fill="#265D91" />
                </svg>Télécharger Réponses</button>
                <!--end::Export-->
                <!--begin::Add customer-->
                <!--end::Add customer-->
              </div>
              <div class="d-flex justify-content-end export" data-kt-customer-table-toolbar="base">

                <!--begin::Export-->
                <button (click)="exportCandidats()" type="button" class="btn btn-light-primary me-3">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.85909 10.3268C5.29968 10.3268 4.74027 10.1071 4.31335 9.68234C3.45951 8.83288 3.45951 7.45618 4.31335 6.59207L7.94952 2.97455H2.56151C1.14826 2.97455 0 4.11692 0 5.52292V11.4106C0 12.8166 1.14826 13.9589 2.56151 13.9589H8.47949C9.89274 13.9589 11.041 12.8166 11.041 11.4106V6.07947L7.40483 9.69699C6.97791 10.1217 6.4185 10.3268 5.85909 10.3268Z"
                      fill="#265D91" />
                    <path
                      d="M13.1904 0.0600586H8.53843C8.09679 0.0600586 7.74347 0.411559 7.74347 0.850934C7.74347 1.29031 8.09679 1.64181 8.53843 1.64181H11.2913L5.29973 7.58802C4.99058 7.89558 4.99058 8.39354 5.29973 8.7011C5.44695 8.84756 5.65304 8.93544 5.85914 8.93544C6.06524 8.93544 6.25662 8.86221 6.41855 8.7011L12.4101 2.74025V5.47902C12.4101 5.91839 12.7634 6.2699 13.2051 6.2699C13.6467 6.2699 14 5.91839 14 5.47902V0.850934C13.9853 0.411559 13.632 0.0600586 13.1904 0.0600586Z"
                      fill="#265D91" />
                  </svg>Exporter </button>
                <!--end::Export-->
                <!--begin::Add customer-->
                <!--end::Add customer-->
              </div>
              <!--end::Toolbar-->
              <div class="d-flex justify-content-end compare" data-kt-customer-table-toolbar="base">

                <!--begin::Export-->
                <button type="button" class="btn btn-light-primary me-3" data-bs-toggle="modal"
                  data-bs-target="#kt_customers_export_modal" data-backdrop="static" [disabled]="selectedCandidats.length == 0">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.85909 10.3268C5.29968 10.3268 4.74027 10.1071 4.31335 9.68234C3.45951 8.83288 3.45951 7.45618 4.31335 6.59207L7.94952 2.97455H2.56151C1.14826 2.97455 0 4.11692 0 5.52292V11.4106C0 12.8166 1.14826 13.9589 2.56151 13.9589H8.47949C9.89274 13.9589 11.041 12.8166 11.041 11.4106V6.07947L7.40483 9.69699C6.97791 10.1217 6.4185 10.3268 5.85909 10.3268Z"
                      fill="#265D91" />
                    <path
                      d="M13.1904 0.0600586H8.53843C8.09679 0.0600586 7.74347 0.411559 7.74347 0.850934C7.74347 1.29031 8.09679 1.64181 8.53843 1.64181H11.2913L5.29973 7.58802C4.99058 7.89558 4.99058 8.39354 5.29973 8.7011C5.44695 8.84756 5.65304 8.93544 5.85914 8.93544C6.06524 8.93544 6.25662 8.86221 6.41855 8.7011L12.4101 2.74025V5.47902C12.4101 5.91839 12.7634 6.2699 13.2051 6.2699C13.6467 6.2699 14 5.91839 14 5.47902V0.850934C13.9853 0.411559 13.632 0.0600586 13.1904 0.0600586Z"
                      fill="#265D91" />
                  </svg>Comparer</button>
                <!--end::Export-->
                <!--begin::Add customer-->
                <!--end::Add customer-->
              </div>
             </div>
             
            </div>
            <!--end::Tab nav-->
            <!--begin::Wrapper-->
  
            <!--end::Wrapper-->
  
            <!--end::Card header-->
            <!--begin::Card body-->
            <div class="card-body">
              <div class="tab-content for-web">
                <!--begin::Tab pane-->
                <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                  <!--begin::Row-->
                  <div class="row g-6 g-xl-9 justify-content-center">
                    <!--begin::Col-->
                    <div class="col-md-6 col-xxl-4" *ngFor="let c of listcandidats ; let i =index" (click)="toggleRowSelection(c)">
                 
                      <!--begin::Card-->
                      <div class="card pt-5 p-5">
                        <div class="form-check" style="margin: 17px;">
                          <input [checked]="c.checked"
                                (change)="changeSelectCandidats($event,'single',c)" class="form-check-input"
                                type="checkbox" value="" id="flexCheckDefault" />
  
                        </div>
                        <div class="tools">
                          <div class="dropdown">
                              <button
                                  class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                  type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false">
                                  <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                          transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                          transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                          fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                          transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                          fill="#265D91" />
                                  </svg>
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                           
                                <a class="dropdown-item"
                                [routerLink]="['/profil-candidats-anonyme',c.id]">Voir
                                profil</a>
                               
                             
                              </div>
                          </div>
                      </div>
                        <!--begin::Card body-->
                        <div class=" d-flex  flex-column justify-content-center mt-10">
                          <!--begin::Avatar-->
                          <div class="symbol symbol-65px symbol-circle mb-5 text-center">
                            <img *ngIf="c.image_url  && c.image_url!='avatar.png' &&  c.image_url!=='undefined'" src="{{url+'/User/file/gallery_users/'+ c.image_url}}" alt="logo" width="50px" height="50px" class="circular-image">
                            <img *ngIf="!c.image_url ||  c.image_url==='undefined'"
                              src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
                            <img *ngIf="c.image_url && (c.image_url=='avatar.jpg' || c.image_url=='avatar.png')"
                              class="table-img" src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
                            
                          </div>
                          <!--end::Avatar-->
                          <!--begin::Name-->
                         <div class="candidat-name text-center mb-2">
                         <span>{{c.first_name}}</span>
                         </div>
                          <!--end::Name-->
                          <!--begin::Position-->
                          <div class="px-4 mx-2 text-center mb-2" >
                            <div class="poste-esn"><span>{{c.desired_workstation}}</span> </div>
                          </div>
                          <div class="px-4 mx-2 text-center" *ngIf="c.years_of_experience && c.years_of_experience !== '0 ans'">
                            <div class="poste-esn"> 
                              <span >
                                {{ c.years_of_experience }} D'experience
                              </span>
                             </div>
                          </div>
                          <!--end::Position-->
                          <!--begin::Info-->
                       
  
                      
  
                          <!--end::Info-->
                        </div>
                        <div class="infoss">
                           
                          <div class="py-3 px-4 mx-2" *ngIf="c.tjm && c.tjm !== '0'">
                            <div class="Tjm-annee"> <span>Tjm :</span>
                              <span >
                                {{ c.tjm + ' €' }}
                              </span>
                              </div>
                          </div>

                          <div class="py-3 px-4 mx-2" *ngIf="c.desired_salary && c.desired_salary !== '0'">
                            <div class="salaire-annee"> <span>Salaire :</span> 
                              <span >
                                {{ c.desired_salary + ' €' }}
                              </span>
                              
                            </div>
                          </div>
                        </div>
                        <div class="foot p-5">
                          <!-- <div class="poste" *ngIf="c.linkedin_link!=null">
                            <span (click)="redirectToLinkedIn(c.linkedin_link)">
                              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_239_1206)">
                                <path d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z" fill="#265D91"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_239_1206">
                                <rect width="17" height="18" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>                              
                            </span>
                          </div> -->
                          <div class="plus">
                            <a [routerLink]="['/profil-candidats-anonyme',c.id]">Voir plus</a>
                          </div>
                        </div>
                 
                      </div>
                      <!--end::Card-->
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->
  
                    <!--end::Col-->
                  </div>
                  <!--end::Row-->
                </div>
                <!--end::Tab pane-->
                <!--begin::Tab pane-->
                <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                  <div class="content">
                    <!--begin::Card header-->
                   
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body pt-15 padding-s">
                      <!--begin::Table-->
                      <div class="table-responsive" id="kt_customers_table">
                        <table class="table align-middle style-table" >
                          <thead>
                            <tr class="text-start text-gray-400 fw-bold text-uppercase gs-0">
                              <th class="min-w-50px th-fixed weight">
                                <div class="form-check form-check-sm form-check-custom form-check-solid"
                                  style="padding-left: 1.25rem;">
                                  <input (change)="changeSelectCandidats($event,'allCandidats')" class="form-check-input"
                                    type="checkbox" value="" id="flexCheckDefault" [checked]="headerChecked" />
                                    
                                </div>
                              </th>
                              <ng-container *ngFor="let item of listNames ;let i =index">
                                <th class="min-w-175px" [ngClass]="{'th-fixed ': item === 'Prenom'}">
                                  <span>{{item}}</span>
                                  <i *ngIf="!['CV','Image','CV WegestU'].includes(item)" (click)="sortData(item)"
                                    class="fa-solid fa-sort cursor-pointer"></i>
                                </th>
                              </ng-container>
  
                              <th class="min-w-125px"><span data-bs-toggle="tooltip" data-bs-placement="top" title="Actions ici">Actions</span></th>
                              <th class="min-w-70px">
                                <div class="dropdown">
                                  <button
                                    class="dropdown-toggle"
                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                      fill="none">
                                      <g filter="url(#filter0_d_588_1699)">
                                        <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                          shape-rendering="crispEdges" />
                                      </g>
                                      <path
                                        d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                        fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                      <defs>
                                        <filter id="filter0_d_588_1699" x="0" y="0" width="28" height="28"
                                          filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                          <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                          <feOffset dy="4" />
                                          <feGaussianBlur stdDeviation="2" />
                                          <feComposite in2="hardAlpha" operator="out" />
                                          <feColorMatrix type="matrix"
                                            values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                          <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_588_1699" />
                                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1699"
                                            result="shape" />
                                        </filter>
                                      </defs>
                                    </svg>
                                  </button>
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <div class="d-flex checkbox mb-2 menu" *ngFor="let item of dataHeader;let i =index">
                                      <div class="form-check form-check-sm form-check-custom form-check-solid"
                                        *ngIf="item.name!='checkbox'">
  
                                        <input class="form-check-input checkbox-border"
                                        [checked]="(item.checked=='oui'&&!item.checked_user)||item.checked_user=='oui'&&(item.checked=='non'||item.checked=='oui')"
                                        (change)="changeSelection($event,item,i)" type="checkbox" value="1" [disabled]="item.name==='Prenom' || item.name==='Image'"/>
                                        <a class="dropdown-item">{{item.name}}</a>
                                      </div>
                                    </div>
                                  </div>
  
                                </div>
                              </th>
                            </tr>
  
                          </thead>
                          <tbody class="fw-semibold text-gray-600">
                            <tr *ngFor="let c of listcandidats;let i=index" (click)="toggleRowSelection(c)">
                              <td  class="wrapping td-fixed weight" >
                                <div class="form-check form-check-sm form-check-custom form-check-solid">
                                  <input class="form-check-input" type="checkbox" [checked]="c.checked"
                                    (change)="changeSelectCandidats($event,'single',c)" class="form-check-input"
                                    type="checkbox" value="" id="flexCheckDefault" />
                                </div>
                              </td>
  
                        
  
                              <td *ngIf="listNames.includes('Image')" >
                              
                                <img *ngIf="c.image_url  && c.image_url!='avatar.png' &&  c.image_url!=='undefined'" src="{{url+'/User/file/gallery_users/'+ c.image_url}}" alt="logo" width="50px" height="50px" class="circular-image">
                                <img *ngIf="!c.image_url ||  c.image_url==='undefined'"
                                  src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
                                <img *ngIf="c.image_url && (c.image_url=='avatar.jpg' || c.image_url=='avatar.png')"
                                  class="table-img" src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
  
                              </td>
  
  
                              <td *ngIf="listNames.includes('Prenom')" 
                              class="wrapping td-fixed">
                              <a class="first-td "
                                  [routerLink]="['/profil-candidats-anonyme',c.id]"><span class="first-td">
                                  {{c.first_name ? c.first_name:'---'}}</span></a> 
                            </td>

  
                              <td *ngIf="listNames.includes('Poste')"
                                class="wrapping"> 
                                <span class="wrapping-poste" *ngIf="c.desired_workstation!=='null'">{{c.desired_workstation?c.desired_workstation:'---'}} </span>
                                <span *ngIf="c.desired_workstation==='null'">---</span>

                              </td>
                          
  
                              <td *ngIf="listNames.includes('Disponibilité')"
                                class="wrapping"><span>
                                  {{c.availability=='1'?'Immédiate':c.availability=='2'?'2 mois':c.availability=='3'?'3 mois':c.availability=='4'?'4 mois':c.availability=='5'?'5 mois':'---'}}</span></td>
  
                              <td *ngIf="listNames.includes('Expérience')"
                                class="wrapping">

                                <span *ngIf="c.years_of_experience!=='0 ans'">{{c.years_of_experience?c.years_of_experience :'---'}}</span>
                                <span *ngIf="c.years_of_experience==='0 ans'">---</span>
                            
                              </td>
  
                              <td *ngIf="listNames.includes('TJM')"
                                class="wrapping">
                                <span *ngIf="c.tjm!=='0'"> {{c.tjm ? c.tjm + ' &euro;' :'---' }}</span> 
                                <span  *ngIf="c.tjm==='0'"> ---</span> 
                              </td>
  
                              <td *ngIf="listNames.includes('Salaire')"
                                class="wrapping">
                                <span *ngIf="c.desired_salary!=='0'"> {{c.desired_salary ? c.desired_salary + ' &euro;' :'---' }}</span> 
                                <span  *ngIf="c.desired_salary==='0'"> ---</span> 
                              
                              </td>
                           
                              <td *ngIf="listNames.includes('Pays de résidence')" 
                                class="wrapping">
                                <span *ngIf="c.current_country!=='null'">{{c.current_country?c.current_country:'---'}}</span>
                                <span *ngIf="c.current_country==='null'">---</span>
                              </td>
                            
  
                              <td *ngIf="listNames.includes('Pays destinataire')" >
                                <span *ngIf="c.destination_country.length !==0">{{c.destination_country}}</span>
                                <span *ngIf="c.destination_country.length ===0">---</span>
                              </td>
  
                          
                              <td *ngIf="listNames.includes('Dernière connexion')"
                                class="wrapping">
                                <span> {{ !c.last_connection ? '---' : c.last_connection.split('
                                  ')[0].split('-').reverse().join('/') }}
                                </span>
                              </td>
  
                          
  
                            
  
                              <td *ngIf="listNames.includes('Score wegestu')">
        
                                <div *ngIf="c.score!==null && c.score!==0" class="d-flex align-items-center flex-column mt-3 w-100">
                                  <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                                    <span>{{c.score + '%'}}</span>
                                  </div>
    
                                  <div class="h-8px mx-3 w-100 bg-light-success rounded">
                                    <div class="bg-success rounded h-8px" role="progressbar"
                                      [style.width.%]="c.score ? c.score : 0" aria-valuemin="0"
                                      aria-valuemax="100">
                                    </div>
                                  </div>
                                </div>
                                <span *ngIf="c.score===null" >---</span>
                                 <span *ngIf="c.score===0" >---</span>
  
                              </td>
  
                              <td *ngIf="listNames.includes('Réponses')">
                     
                                <a *ngIf="c?.file_test_anonymous"
                                (click)="downloadFiles('single',c,'response'); $event.stopPropagation()"
                                class="file-cursor cursor-pointer"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                    fill="#F58F29" />
                                </svg>
                              </a>
                                <span *ngIf="!c.file_test_anonymous">---</span>
                            
                              </td>
  
                  
                              <td>
                                <div class="dropdown">
                                  <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                        fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                    </svg>
                                  </button>
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item"
                                      [routerLink]="['/profil-candidats-anonyme',c.id]">Voir
                                      profil</a>
                                   
  
                                  </div>
                                </div>
                              </td>
  
                            </tr>
  
                          </tbody>
                        </table>
                     
                        <!--end::Card-->
                    
                      </div>
                     
                    </div>
                  
                    <!--end::Card body-->
                  </div>
               
                </div>
                <div class="pagination" *ngIf="listcandidats && listcandidats.length">
                  <app-pagination [data]="listcandidats" [currentPageList]="currentPage" [endexPageList]="endIndex" [lengthData]="totalItems" (setPages)="getItems($event)"
                    >
                  </app-pagination>
                </div>
                <div class="alert alert-warning text-center mt-5" role="alert"
                *ngIf="listcandidats && !listcandidats.length">
                    <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                    <span class="empty-list">
                        La liste est vide
                    </span>
                </div>
                <!--end::Tab pane-->
              </div>
              
              <!--end::Table-->
            </div>

            <div class="card-body">
              <div class="tab-content for-mobile">
                <!--begin::Tab pane-->
                <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                  <!--begin::Row-->
                  <div class="row g-6 g-xl-9 justify-content-center">
                    <!--begin::Col-->
                    <div class="col-md-6 col-xxl-4" *ngFor="let c of listcandidats ; let i =index" (click)="toggleRowSelection(c)">
                      
                      <!--begin::Card-->
                      <div class="card pt-5 p-5">
                        <div class="py-3 px-4 mx-2">
                          <div class="badge-annee" style="width: fit-content;"> <span>Poste :</span> 
                            <span *ngIf="c.desired_workstation!=='null'">{{c.desired_workstation?c.desired_workstation:'---'}} </span>
                            <span *ngIf="c.desired_workstation==='null'">---</span>
                        </div>
                        </div>
                        <!--begin::Card body-->
                        <div class="card-body d-flex flex-center flex-column">
                          <!--begin::Avatar-->
                          <div class="symbol symbol-65px symbol-circle mb-5">
                      
                            <img *ngIf="c.image_url  && c.image_url!='avatar.png' &&  c.image_url!=='undefined'" src="{{url+'/User/file/gallery_users/'+ c.image_url}}" alt="logo" width="50px" height="50px" class="circular-image">
                            <img *ngIf="!c.image_url ||  c.image_url==='undefined'"
                              src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
                            <img *ngIf="c.image_url && (c.image_url=='avatar.jpg' || c.image_url=='avatar.png')"
                              class="table-img" src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
                          
                          </div>
                          <!--end::Avatar-->
                          <!--begin::Name-->
                          <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0"><span>{{c.first_name}}</span></a>
                          <!--end::Name-->
                          <!--begin::Position-->
                          <!--end::Position-->
                          <!--begin::Info-->
                          <div class="content-card">
                  
                          
  
                          <div class="info mt-5">
                           
                            <div class="py-3 px-4 mx-2">
                              <div class="badge-annee"> <span>Tjm :</span> {{c.tjm ? c.tjm + ' &euro;' :'---' }} </div>
                            </div>
  
                            <div class="py-3 px-4 mx-2">
                              <div class="badge-annee"> <span>Salaire :</span> {{c.desired_salary ? c.desired_salary + ' &euro;':'---'}}
                              </div>
                            </div>
                          </div>
                          <div class="py-3 px-4 mx-2">
                            <div class="badge-annee"> <span>ANS.EXP :</span> {{c.years_of_experience ?
                              c.years_of_experience : '---' }} </div>
                          </div>
                          
                            <!--end::Stats-->
                            <!--begin::Stats-->
  
  
                            <!--end::Stats-->
                          </div>
  
                        </div>
                        <div class="foot p-5">
                          <div class="poste" *ngIf="c.linkedin_link!=null">
                            <span (click)="redirectToLinkedIn(c.linkedin_link)">
                              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_239_1206)">
                                <path d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z" fill="#265D91"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_239_1206">
                                <rect width="17" height="18" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>                              
                            </span>
                          </div>
                          <div class="plus">
                            <a [routerLink]="['/profil-candidats-anonyme',c.id]">Voir plus</a>
                          </div>
                        </div>
            
                      </div>
                      <!--end::Card-->
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->
  
                    <!--end::Col-->
                  </div>
                  <!--end::Row-->
                </div>
                <!--end::Tab pane-->
                <!--begin::Tab pane-->
                <div id="kt_project_targets_table_pane" class="tab-pane fade ">
                  <div class="content">
                    <!--begin::Card header-->
                   
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body pt-15 padding-s">
                      <!--begin::Table-->
                      <div class="table-responsive">
                        <table class="table align-middle fs-6 style-table" id="kt_customers_table">
                          <thead>
                            <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                              <tr class="text-start text-gray-400 fw-bold text-uppercase gs-0">
                                <th class="min-w-50px th-fixed weight">
                                  <div class="form-check form-check-sm form-check-custom form-check-solid"
                                    style="padding-left: 1.25rem;">
                                    <input (change)="changeSelectCandidats($event,'allCandidats')" class="form-check-input"
                                      type="checkbox" value="" id="flexCheckDefault" [checked]="headerChecked" />
                                  </div>
                                </th>
                                <ng-container *ngFor="let item of listNames ;let i =index">
                                  <th class="min-w-175px" [ngClass]="{'th-fixed ': item === 'Nom'}">
                                    <span>{{item}}</span>
                                    <i *ngIf="!['CV','Image','CV WegestU'].includes(item)" (click)="sortData(item)"
                                      class="fa-solid fa-sort cursor-pointer"></i>
                                  </th>
                                </ng-container>
    
                                <th class="min-w-125px"><span data-bs-toggle="tooltip" data-bs-placement="top" title="Actions ici">Actions</span></th>
                                <th class="min-w-70px">
                                  <div class="dropdown">
                                    <button
                                      class="dropdown-toggle"
                                      type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                      aria-expanded="false">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                        fill="none">
                                        <g filter="url(#filter0_d_588_1699)">
                                          <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                            shape-rendering="crispEdges" />
                                        </g>
                                        <path
                                          d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                          fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                        <defs>
                                          <filter id="filter0_d_588_1699" x="0" y="0" width="28" height="28"
                                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset dy="4" />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                              values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                              result="effect1_dropShadow_588_1699" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1699"
                                              result="shape" />
                                          </filter>
                                        </defs>
                                      </svg>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                      <div class="d-flex checkbox mb-2 menu" *ngFor="let item of dataHeader;let i =index">
                                        <div class="form-check form-check-sm form-check-custom form-check-solid"
                                          *ngIf="item.name!='checkbox'">
    
                                          <input class="form-check-input checkbox-border"
                                          [checked]="(item.checked=='oui'&&!item.checked_user)||item.checked_user=='oui'&&(item.checked=='non'||item.checked=='oui')"
                                          (change)="changeSelection($event,item,i)" type="checkbox" value="1" />
                                          <a class="dropdown-item">{{item.name}}</a>
                                        </div>
                                      </div>
                                    </div>
    
                                  </div>
                                </th>
                            </tr>
  
                          </thead>
                          <tbody class="fw-semibold text-gray-600">
                            <tr *ngFor="let c of listcandidats;let i=index" >
                              <td class="wrapping td-fixed weight">
                                <div class="form-check form-check-sm form-check-custom form-check-solid">
                                  <input class="form-check-input" type="checkbox"          
                                  [checked]="headerChecked?headerChecked:c.headerChecked"  (change)="changeSelectCandidats($event,'single',c)" class="form-check-input"
                                    type="checkbox" value="" id="flexCheckDefault"  [checked]="c.checked" />
                                </div>
                              </td>
                              <td *ngIf="listNames.includes('Image')">
                              
                                <img *ngIf="c.image_url  && c.image_url!='avatar.png' &&  c.image_url!=='undefined'" src="{{url+'/User/file/gallery_users/'+ c.image_url}}" alt="logo" width="50px" height="50px" class="circular-image">
                                <img *ngIf="!c.image_url ||  c.image_url==='undefined'"
                                  src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
                                <img *ngIf="c.image_url && (c.image_url=='avatar.jpg' || c.image_url=='avatar.png')"
                                  class="table-img" src="/assets/media/icons/avatar.jpg" alt="" width="50px" height="50px" class="circular-image">
  
                              </td>
  
  
                              <td *ngIf="listNames.includes('Prenom')"
                                class="wrapping">
                                <a><span class="first-td"
                                    [routerLink]="['/profil-candidats-anonyme',c.id]">
                                    {{c.first_name}}</span> </a>
                              </td>
  
                              <td *ngIf="listNames.includes('Poste')"
                                class="wrapping">  <span *ngIf="c.desired_workstation!=='null'">{{c.desired_workstation?c.desired_workstation:'---'}} </span>
                                <span *ngIf="c.desired_workstation==='null'">---</span>
                              </td>
  
                              <td *ngIf="listNames.includes('Disponibilité')"
                                class="wrapping"><span>
                                  {{c.availability=='1'?'Immédiate':c.availability=='2'?'2 mois':c.availability=='3'?'3 mois':c.availability=='4'?'4 mois':c.availability=='5'?'5 mois':'---'}}</span></td>
  
                              <td *ngIf="listNames.includes('Expérience')"
                                class="wrapping">
                                <span *ngIf="c.years_of_experience!=='0 ans'">{{c.years_of_experience?c.years_of_experience :'---'}} ans </span>
                              <span *ngIf="c.years_of_experience==='0 ans'">---</span>
                              </td>
  
                              <td *ngIf="listNames.includes('TJM')"
                                class="wrapping">
                          
                                <span *ngIf="c.tjm!=='0'"> {{c.tjm ? c.tjm + ' &euro;' :'---' }}</span> 
                              <span  *ngIf="c.tjm==='0'"> ---</span> 
                              </td>
  
                              <td *ngIf="listNames.includes('Salaire')"
                                class="wrapping">
                               <span *ngIf="c.desired_salary!=='0'"> {{c.desired_salary ? c.desired_salary + ' &euro;' :'---' }}</span> 
                              <span  *ngIf="c.desired_salary==='0'"> ---</span> 
                              </td>
                              <td *ngIf="listNames.includes('N°Tel')" 
                                class="wrapping"><span>{{c.phone_number?c.phone_number:'---'}}</span></td>
                              <td *ngIf="listNames.includes('Pays de résidence')"
                                class="wrapping">
                                <span *ngIf="c.current_country!=='null'">{{c.current_country?c.current_country:'---'}}</span>
                              <span *ngIf="c.current_country==='null'">---</span>
                              </td>
                            
  
                              <td *ngIf="listNames.includes('Pays destinataire')">
                                <span *ngIf="c.destination_country.length !==0">{{c.destination_country}}</span>
                              <span *ngIf="c.destination_country.length ===0">---</span>
                              </td>
  
                          
                         
  
                          
  
                            
  
                              <td *ngIf="listNames.includes('Score wegestu')">
        
                                <div *ngIf="c.score!==null && c.score!==0" class="d-flex align-items-center flex-column mt-3 w-100">
                                  <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                                    <span>{{c.score + '%'}}</span>
                                  </div>
    
                                  <div class="h-8px mx-3 w-100 bg-light-success rounded">
                                    <div class="bg-success rounded h-8px" role="progressbar"
                                      [style.width.%]="c.score ? c.score : 0" aria-valuemin="0"
                                      aria-valuemax="100">
                                    </div>
                                  </div>
                                </div>
                                <span *ngIf="c.score===null" >---</span>
                                 <span *ngIf="c.score===0" >---</span>
  
                              </td>
  
                              <td *ngIf="listNames.includes('Réponses')">
                               
                                <a
                                  *ngIf="c?.file_test" class="file-cursor" style="cursor: pointer;"
                                  (click)="downloadFiles('single', c, 'response')"class="file-cursor" [attr.disabled]="downloadCounter >= 2 ? true : null">
                                  <svg width="26" height="26" viewBox="0 0 26 26"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                      fill="#F58F29" />
                                  </svg>
                                </a>
                                <span *ngIf="!c.file_test">---</span>
                            
                              </td>
  
                            
                              <td>
                                <div class="dropdown">
                                  <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                        fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                    </svg>
                                  </button>
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item"
                                      [routerLink]="['/profil-candidats-anonyme',c.id]">Voir
                                      profil</a>
                                  
  
                                  </div>
                                </div>
                              </td>
  
                            </tr>
  
                          </tbody>
                        </table>
                  
                      </div>
  
                    </div>
                    <!--end::Card body-->
                  </div>
                </div>
                <!--end::Tab pane-->
              </div>
              <!--end::Table-->
            </div>

            <!--end::Card body-->
       
  
  
         
        </div>
 
      </div>
      <!--end::Card-->
     
        <!--end::Content container-->
      </div>
  
      <!--end::Content-->
    </div>

  </div>
  <div class="modal" id="kt_customers_export_modal">
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
      <!--begin::Modal content-->
      <div class="modal-content pt-5  pb-15">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="fw-bold"></h2>
          <!--end::Modal title-->
          <!--begin::Close-->
         
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body text-center mx-5 mx-xl-15 my-7">
          <!--begin::Form-->
          <div class="h4">Voulez-vous créer un scoring
            pour la comparaison ?</div>
          <!--end::Form-->
        </div>
        <div class="card-footer text-center">
          <div class="actions">
            <a  data-bs-dismiss="modal" aria-label="Close" class="annuler">Annuler</a>
            <a  (click)="navigateToCompareCandidats()" class="confirmer">Confirmer</a>
          </div>
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>